/**
 * Mint referral cookie utilities
 *
 * Per-launch referral attribution via cookies.
 * Cookie name: mref_{launchId}
 * Cookie expiry: 30 days
 * Attribution model: last-click wins
 */

const COOKIE_DAYS = 30;

function setCookie(name: string, value: string, days: number): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

function getCookie(name: string): string | null {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(nameEQ)) {
      return decodeURIComponent(cookie.substring(nameEQ.length));
    }
  }
  return null;
}

/**
 * Store a mint referral code for a specific launch.
 * Last-click wins: overwrites any previous referral for this launch.
 */
export function captureMintReferral(launchId: string, code: string): void {
  if (code && code.trim() && launchId) {
    setCookie(`mref_${launchId}`, code.trim().toUpperCase(), COOKIE_DAYS);
  }
}

/**
 * Get the stored mint referral code for a specific launch.
 * Returns null if no referral cookie exists for this launch.
 */
export function getMintReferralCode(launchId: string): string | null {
  if (!launchId) return null;
  return getCookie(`mref_${launchId}`);
}
